import { isPopDevToolsEnabled } from '../enabled';
import { popDevTools } from '../pop-devtools';
import { extractCorrelationFields, summarizeArgs, summarizeValue } from './summary';

type IpcReceiveRegistrar = (callback: (type: any, ...handlerArgs: any[]) => void | symbol) => () => void;

const POP_DEVTOOLS_RELAY_EVENT = 'onPopDevToolsEvents';

let unregisterReceiveTap: (() => void) | undefined;

export const recordIpcSend = (type: string, args: readonly unknown[]) => {
  if (!isPopDevToolsEnabled()) return;

  try {
    const correlation = extractCorrelationFields(...args);
    popDevTools.record({
      channel: 'ipc',
      level: 'debug',
      message: `send ${String(type)}`,
      data: {
        type,
        args: summarizeArgs(args),
      },
      ...correlation,
    });
  } catch (_error) {
    // Instrumentation must never block IPC delivery.
  }
};

export const recordIpcAnswer = (
  type: string,
  args: readonly unknown[],
  response: unknown,
  durationMs: number,
) => {
  if (!isPopDevToolsEnabled()) return;

  try {
    const correlation = extractCorrelationFields(response, ...args);
    popDevTools.record({
      channel: 'ipc',
      level: 'debug',
      message: `answer ${String(type)} ${Math.round(durationMs)}ms`,
      data: {
        type,
        durationMs,
        args: summarizeArgs(args),
        response: summarizeValue(response),
      },
      ...correlation,
    });
  } catch (_error) {
    // Instrumentation must never block IPC delivery.
  }
};

const recordIpcReceive = (type: string, handlerArgs: readonly unknown[]) => {
  if (!isPopDevToolsEnabled() || type === POP_DEVTOOLS_RELAY_EVENT) return;

  try {
    const correlation = extractCorrelationFields(...handlerArgs);
    popDevTools.record({
      channel: 'ipc',
      level: 'debug',
      message: `receive ${type}`,
      data: {
        type,
        args: summarizeArgs(handlerArgs),
      },
      ...correlation,
    });
  } catch (_error) {
    // Instrumentation must never block IPC delivery.
  }
};

export const installIpcReceiveTap = (registerIpcReceiveCallback: IpcReceiveRegistrar) => {
  if (unregisterReceiveTap || !isPopDevToolsEnabled()) return;

  unregisterReceiveTap = registerIpcReceiveCallback((type, ...handlerArgs) => {
    recordIpcReceive(String(type), handlerArgs);
  });
};

const uninstallIpcReceiveTapForTests = () => {
  unregisterReceiveTap?.();
  unregisterReceiveTap = undefined;
};
